import { registerPlugin } from '@capacitor/core';

import { IntercomPluginInterface } from './definitions';
import { CAPACITOR_INTERCOM_PLUGIN_NAME } from '../pluginConstants';

const IntercomPlugin = registerPlugin<IntercomPluginInterface>(CAPACITOR_INTERCOM_PLUGIN_NAME);

export * from './definitions';
export { IntercomPlugin };
